import { Alert, Box, Button, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, TextField } from '@mui/material';
import React, { Component } from 'react';
import axios from 'axios';
import Global from '../../customlib/Global';
import Api from '../../customlib/Api';
import { Warning } from '@mui/icons-material';

class InputHasilTraining extends Component {
    state = { 
        customer: {},
        isSaving: false,
        errorMessage: "",
        showTodoConfirmation: false,
        toggleApprovalDisabled: true
    } 

    initTrainingResultObject = {
        _id: "",
        id: "",
        fiveWhysId: "",
        skenario: "",
        paham: false, 
        userId: 0,
        userName: ""
    };

    componentDidMount() {
        
        let customerData = this.props.data ?? null;
        if(customerData && !this.props.data?.training_result){
            customerData.training_result = this.initTrainingResultObject;
            customerData.training_result.fiveWhysId = this.props.data?.five_whys._id
            customerData.training_result.userId = Global.get().user.id;
            customerData.training_result.userName = Global.get().user.name;
        }else{
            customerData.training_result.id = customerData.training_result._id
        }
        this.setState({customer: customerData}, () => {
            console.log("INPUT_FIVE",this.state.customer);
            // this.toggleApprovalDisabled();
        });
        
    }

    handleUpdateWhy = (event, index) => {
        console.log("INPUT_FIVE", index, event.target.value, this.state.customer?.five_whys?.issueCategory, this.state.customer?.five_whys?.todo);

        let customer = {...this.state.customer};
        let whys = customer.five_whys.whys;

        whys[index].why_value = event.target.value;

        this.setState({customer: customer});

    }

    handleIssueChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.issue = event.target.value;

        this.setState({customer: customer});
    }

    handleIssueDescriptionChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.issueDescription = event.target.value;

        this.setState({customer: customer});
    }

    handleSolutionChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.solution = event.target.value;

        this.setState({customer: customer});
    }

    handleIssueCategoryChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.issueCategory = event.target.value;

        this.setState({customer: customer});
    }

    handleTodoChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.todo = event.target.value;

        this.setState({customer: customer});
    }
    
    handleStatusChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.five_whys;

        fiveWhys.status = event.target.checked ? "APPROVED" : "NOT APPROVED";

        this.setState({customer: customer});
    }

    handleSkenarioChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.training_result;

        fiveWhys.skenario = event.target.value;

        this.setState({customer: customer});
    }

    handlePahamChange = (event) => {
        let customer = {...this.state.customer};
        let fiveWhys = customer.training_result;

        fiveWhys.paham = event.target.checked ;

        this.setState({customer: customer});
    }

    handleSaveTrainingResult = () => {
      
        this.setState({isSaving: true}, ()=>{
        const params = {...this.state.customer.training_result};
        console.log("INPUT_FIVE", params);
        // return;
        axios
            .post(Api.teleTrainingSave(), params, Api.getRequestHeader())
            .then((response) => {
            console.log("YOUR_MESSAGES",response.data);
            
            let responseData = response.data;
            if(responseData.success){
                this.setState({ errorMessage: "", isSaving: false }, () => {
                    this.props.onReload();
                    this.props.onClose(null);
                });
            }else{
                this.setState({ errorMessage: responseData.message, isSaving: false });
            }
            
            })
            .catch((error) => {
                this.setState({ errorMessage: error.message, isSaving: false });
                console.error("There was an error!", error);
            });
        });
    
        
    };

    toggleApprovalDisabled = () => {

        let isDisabled = true;

        if(this.state.customer.five_whys._id && this.state.customer.five_whys._id.length > 0){
            isDisabled = false; 
        }

        let isAdmin = Global.get().admin;
        let isAdminTeleUser = Global.isAdminTeleUser();
        let isTeleAdmin = Global.isTeleAdmin();

        console.log("INPUT_FIVE_DATA", this.state.customer.five_whys);
        console.log("INPUT_FIVE_admin", isAdmin, isAdminTeleUser, isTeleAdmin);

        if(isAdmin || isAdminTeleUser || isTeleAdmin){
            if(this.state.customer.five_whys.status === "APPROVED"){
                isDisabled = true;
            }else{
                isDisabled = false;                
            }
        }

        this.setState({toggleApprovalDisabled: isDisabled});

        return isDisabled;
    }

    handleHideTodoConfirmation = () => {
        this.setState({showTodoConfirmation: false});
    }

    handleShowTodoConfirmation = () => {
        this.setState({showTodoConfirmation: true});
    }

    render() { 
        return (
            <Box>
                {
                    this.state.errorMessage && this.state.errorMessage.length > 0 && 
                    <Alert variant='filled' icon={<Warning fontSize="inherit" />} severity="error">
                        {this.state.errorMessage}
                    </Alert>
                }
                <Box sx={{fontWeight: "bold"}}>Customer : {this.state.customer?.fromName}</Box>
                {/* <Grid container spacing={1}>
                    <Grid item xs={2}>Customer</Grid> 
                    <Grid item xs={10}>: {this.state.customer?.fromName}</Grid> 
                </Grid> */}
                
                <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                    <TextField
                    id="txt-issue"
                    label="Issue"
                    multiline
                    maxRows={4}
                    onChange={this.handleIssueChange}
                    value={this.state.customer?.five_whys?.issue}
                    size='small'
                        disabled
                    />
                </FormControl>

                <Grid container spacing={1}>
                    {
                        this.state.customer && this.state.customer?.five_whys && this.state.customer?.five_whys?.whys.map((item, index) => {
                            return <Grid item xs={index+1 === this.state.customer?.five_whys?.whys.length ? 12 : 6}>
                                <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                                    <TextField
                                    id={`txt-why-${index}`}
                                    label={`Why ${index+1}`}
                                    multiline
                                    maxRows={4}
                                    onChange={(event) => this.handleUpdateWhy(event, index)}
                                    value={item.why_value}
                                    size='small'
                        disabled
                                    />
                                </FormControl>
                            </Grid>
                        })
                    }
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                            <TextField
                            id="txt-issue-description"
                            label="Issue Description"
                            multiline
                            maxRows={4}
                            onChange={this.handleIssueDescriptionChange}
                            value={this.state.customer?.five_whys?.issueDescription}
                            size='small'
                            disabled
                            />
                        </FormControl>
                    </Grid> 
                    <Grid item xs={6}>
                        <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                            <TextField
                            id="txt-solution"
                            label="Solution"
                            multiline
                            maxRows={4}
                            onChange={this.handleSolutionChange}
                            value={this.state.customer?.five_whys?.solution}
                            size='small'
                            disabled
                            />
                        </FormControl>
                    </Grid> 
                </Grid>

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                            <TextField
                                id="txt-issue-category"
                                label="Solution"
                                multiline
                                maxRows={4}
                                // onChange={this.handleSolutionChange}
                                value={this.state.customer?.five_whys?.issueCategory}
                                size='small'
                                disabled
                            />
                        </FormControl>
                    </Grid> 
                    <Grid item xs={6}>
                        <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                            <TextField
                                id="txt-todo"
                                label="Solution"
                                multiline
                                maxRows={4}
                                // onChange={this.handleSolutionChange}
                                value={this.state.customer?.five_whys?.todo}
                                size='small'
                                disabled
                            />
                        </FormControl>
                    </Grid> 
                </Grid>
                <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                    <TextField
                        id="txt-skenario"
                        label="Skenario"
                        multiline
                        maxRows={5}
                        onChange={this.handleSkenarioChange}
                        value={this.state.customer?.training_result?.skenario}
                        size='small'
                    />
                </FormControl>

                <Divider sx={{mt: "10px", mb: "10px"}} />

                <Box sx={{textAlign: "right"}}>
                    <Grid container spacing={1}>
                        <Grid item xs={5} sx={{textAlign: "left"}}>
                            <FormControlLabel disabled={this.state.toggleApprovalDisabled} control={<Switch defaultChecked />} label={this.state.customer?.five_whys?.status === "APPROVED" ? "Approved" : "Not Approved"} onChange={this.handleStatusChange} checked={this.state.customer?.five_whys?.status === "APPROVED"} />
                            <FormControlLabel control={<Switch defaultChecked />} label={"Saya sudah mengerti"} onChange={this.handlePahamChange} checked={this.state.customer?.training_result?.paham === true} />
                        </Grid>
                        <Grid item xs={7}>
                            {
                                this.state.showTodoConfirmation && (
                                    <Box>
                                        <Alert 
                                            variant='filled'
                                            icon={<Warning fontSize="inherit" />} 
                                            severity="error" 
                                            action={
                                            <Box>
                                                <Button onClick={this.handleSaveTrainingResult} variant='contained' color="primary" size="small">
                                                    Ya, Simpan
                                                </Button>
                                                &nbsp;
                                                <Button onClick={this.handleHideTodoConfirmation} variant='contained' color="warning" size="small">
                                                    Batal
                                                </Button>
                                            </Box>
                                        }>
                                            Yakin akan disimpan ?
                                        </Alert>
                                    </Box>
                                )
                            }
                            {
                                !this.state.showTodoConfirmation && <Button color='primary' variant='contained' size='small' onClick={this.handleShowTodoConfirmation} disabled={this.state.isSaving}>Simpan</Button>
                            }
                            
                            &nbsp;
                            {
                                !this.state.showTodoConfirmation && <Button color='error' variant='contained' size='small' onClick={() => this.props.onClose(null)}>Tutup</Button>
                            }
                            
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        );
    }
}
 
export default InputHasilTraining;